import { toast } from "react-toastify";

import TransporterClient from "../../../api/transporter";

toast.configure();

export const transporters = {
  state: {
    transporters: [],
    selectedTransporters: [],
    filteredTransportersString: "",
    filterState: [],
  },
  reducers: {
    setFiltered(state, payload) {
      return {
        ...state,
        filterState: payload,
      };
    },
    setTransportersString(state, payload) {
      return {
        ...state,
        filteredTransportersString: payload
          ? payload.map((i) => i && i.value).join()
          : "",
      };
    },
    setTransporters(state, payload) {
      return {
        ...state,
        transporters: payload,
      };
    },
    setSelectedTransporters(state, payload) {
      return {
        ...state,
        selectedTransporters: payload,
      };
    },
    clearStore() {
      return {};
    },
  },
  effects: (dispatch) => ({
    async setFilteredAsync(payload, rootState) {
      if (!Array.isArray(payload)) {
        const storage = localStorage.getItem('selectedTransporter');
        if (storage) {
          payload = JSON.parse(storage);
          this.setTransportersString(payload);
        }
      }

      this.setFiltered(payload)
    },
    async setTransportersStringAsync(payload, rootState) {
      await this.setTransportersString(rootState.transporters.filterState);
      localStorage.setItem('selectedTransporter', JSON.stringify(rootState.transporters.filterState));
    },
    async setSelectedAsync(payload, rootState) {
      await this.setSelectedTransporters(payload);
    },
    async loadTransportersAsync() {
      try {
        const { data } = await TransporterClient.getUserTransporters();
        this.setTransporters(data);
      } catch (error) {
        return null;
      }
    },
    async loadTransporterByCNPJ(payload) {
      try {
        const { data } = await TransporterClient.getTranporterByCNPJ(payload)
        return data
      } catch (error) {
        return null
      }
    },
    async loadTransportersByNicknameAsync(nickname) {
      try {
        const { data } = await TransporterClient.getTransportersByNickname(nickname);
        return data;
      } catch (error) {
        toast.error(`Erro ao carregar transportadora com o apelido ${nickname}`)
      }
    },
    async loadTransportersByDocumentAsync(documentNumber) {
      try {
        const document = documentNumber.replace(/\D/g, '');
        const { data } = await TransporterClient.getTransportersByDocument(document);
        return data;
      } catch (error) {
        toast.error(`Erro ao carregar transportadora com o documento ${documentNumber}`);
      }
    }
  }),
};
